export default {
  content: [
    {
      id: 'A',
      question: "What is the answer to life the universe and everything?",
      answer: 42
    },
    {
      id: 'B',
      question: "What percent of people are born without wisdom teeth?",
      answer: "35%"
    },
    {
      id: 'C',
      question: "What was the profession of the inventor of cotton candy?",
      answer: "Dentist"
    },
    {
      id: 'D',
      question: "What percent of people dream in black and white?",
      answer: "Twelve percent."
    },
    {
      id: 'E',
      question: "Oreo cookies are a knock-off of another type of cookie. What was the original cookie's name?",
      answer: "Hydrox"
    },
    {
      id: 'F',
      question: "Who was the first president?",
      answer: "George Washington"
    },
  ],
  initDeck() {
    return {
      startTime: new Date(),
      endTime: null,
      totalCards: null,
      assessKnown: 0,

    }
  },
}
